<script lang="ts">
	import { getRentalTemplateContext } from "./rental-template-context.svelte";
	const templateContext = getRentalTemplateContext()!;
</script>

<footer class="bg-neutral-900 text-white">
	<div class="container mx-auto px-4 py-12">
		<div class="mb-8 flex flex-col items-center justify-between md:flex-row md:items-start">
			<div class="mb-8 md:mb-0">
				<img
					src={templateContext.logo}
					alt={templateContext.name}
					class="mb-4 h-16 w-auto"
					width="300"
					height="64"
					loading="lazy"
				/>
			</div>

			<div class="mb-8 text-center md:mb-0 md:text-left">
				<p class="mb-2">{templateContext.address.street}</p>
				<p class="mb-4">
					{templateContext.address.city}, {templateContext.address.state}
					{templateContext.address.zip}
				</p>
				<p class="mb-2">{templateContext.contact.phone}</p>
				<p>{templateContext.contact.email}</p>
			</div>

			<div class="text-center md:text-left">
				<h3 class="mb-4 text-lg font-semibold">ONLINE PORTAL</h3>
				<div class="flex space-x-4">
					<a
						href={templateContext.overrides?.residentPortalUrl ??
							templateContext.tenantPortal}
						target="_blank"
						rel="noopener noreferrer"
						class="transition-colors hover:text-amber-300">Log In | Sign Up</a
					>
				</div>
			</div>
		</div>

		<div
			class="flex flex-col items-center justify-between border-t border-gray-800 pt-6 md:flex-row"
		>
			<p class="w-full text-left text-sm">
				<a href="/sitemap.xml" class="text-white">Sitemap</a>
			</p>
			<p class="w-full text-right text-sm">
				© {new Date().getFullYear()} All Rights Reserved | {templateContext.name}
			</p>
		</div>
	</div>
</footer>
